// ---------------------------------------------------------------------------
// Latency grader constants — kept in a dependency-free module so both the eager
// Overview path (LatencyOverviewSections) and the lazy create flow can share the
// default metric name without the Overview path transitively importing the
// create hook's HttpClient graph.
// ---------------------------------------------------------------------------

/** Default metric name the backend emits when `init.metricName` is omitted. */
export const DEFAULT_LATENCY_METRIC_NAME = 'latencyMs';
